import { render } from "./CreateModule.vue?vue&type=template&id=e9cba4ac"
import script from "./CreateModule.vue?vue&type=script&lang=js"
export * from "./CreateModule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__